import { useState, createContext } from "react";

export const DropdownContext = createContext();
export const DropdownProvider = ({ children }) => {
  const [dropdownvalue, setDropdownValue] = useState([]);

  return (
    <DropdownContext.Provider value={{ dropdownvalue, setDropdownValue }}>
      {children}
    </DropdownContext.Provider>
  );
};
